//bao migrate skip
import TabPage from "./../factories/tab-page";
import "./../bindings/bao-searcher";
import * as $ from "jquery";
import BaseViewModel from "./../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import TabController from "./../factories/tab-controller";
import * as moment from "moment";
//import BaoDialog = window.baorequire('Factories/baoDialog');
//var finitoService = window.baorequire('Services/FinitoService');
class ShiftScheduleViewModel extends BaseViewModel {
    CompleteCheck(): boolean | JQueryPromise<boolean> {
        return true;
    }
    Years: number[] = [];
    ShiftEntries: any[];
    ShiftScheduleItems: any[];
    Months: any[] = [];
    Calendar: any[];
    Week: number = 0;
    // pass moment to view
    moment = moment;
    // filters
    SelectedYear: KnockoutObservable<number> = ko.observable(new Date().getFullYear());
    SelectedEmployeeId: KnockoutObservable<string> = ko.observable(undefined);
    PersonFullName: KnockoutObservable<string> = ko.observable("");
    ShiftScheduleCalendar: KnockoutObservableArray<any> = ko.observableArray([]);
    HeaderLeftPos: KnockoutObservable<string> = ko.observable('0');
    FiltersEnabled: KnockoutObservable<boolean> = ko.observable(false);
    PermissionRefresh: KnockoutObservable<string> = ko.observable("na");
    PermissionSave: KnockoutObservable<string> = ko.observable("na");
    PermissionDelete: KnockoutObservable<string> = ko.observable("na");
    PermissionQRCode: KnockoutObservable<string> = ko.observable("na");
    constructor(tabPage: TabPage) {
        super(tabPage);
        this.SelectedYear.subscribe(_ => this.refresh());
        this.SelectedEmployeeId.subscribe(_ => this.refresh());
        this.TabPage.MenuEvents.push(this.Menu.registerEvent((btnClicked) => {
            if (this.TabPage.IsActiveTab() !== true) {
                return;
            }
            if (btnClicked.ActionKey() === "FullYearScheduleRefresh") {
                this.refresh();
            }
        }));
    }
    // required by base class
    InitUrl() {
        return "";
    }
    loadMetaData() {
        return Bao.post("ShiftSchedule/FullYearScheduleMetaData")
            .done(result => {
            //ko.map.fromJS(result, this); this maps also properties to observables
            //this.Years = result.Years;
            var DatumAkt = new Date();
            var JahrAkt = DatumAkt.getFullYear();
            for (var r in result.Years) {
                if (result.Years[r].Key != "" && result.Years[r].Key != null)
                    this.Years.push(result.Years[r].Key);
            }
            this.SelectedYear(JahrAkt);
            for (var r in result.Months) {
                this.Months.push(result.Months[r]);
            }
            if (result.CurrentPerson != null) {
                this.SelectedEmployeeId(result.CurrentPerson.ConfigurationItemId);
                this.PersonFullName(result.CurrentPerson.FullName);
            }
            this.ShiftEntries = result.ShiftEntries;
            //this.Months = result.Shift            
            this.TabPage.Title(result.TabTitle);
        });
    }
    refresh() {
        this.TabPage.IsLoading(true);
        this.loadSchedule().always(() => {
            this.TabPage.IsLoading(false);
        });
    }
    loadSchedule() {
        if (this.SelectedYear() === null || this.SelectedEmployeeId() === null) {
            this.ShiftScheduleCalendar([]);
            return $.Deferred<any>().resolve().promise();
        }
        return Bao.post("ShiftSchedule/FullYearScheduleData?year=" + this.SelectedYear() + "&employeeId=" + this.SelectedEmployeeId())
            .done(result => {
            //ko.map.fromJS(result, this); this maps also properties to observables
            //this.Months = result.ShiftScheduleCalendar.map(v => v.Month).filter( (v, i, a) => a.indexOf(v) === i );
            this.ShiftScheduleCalendar(result.ShiftScheduleCalendar);
        });
    }
    init() {
        this.TabPage.IsLoading(true);
        this.FiltersEnabled = Bao.Session.HasPermission("TeamScheduleFilterShiftPlan", '1A38B671-948C-42EE-B80D-F6B9A12814B6');
        return $.when(super.init(), this.loadMetaData());
    }
    loaded() {
        super.loaded();
        window.addEventListener('scroll', (e) => {
            e.preventDefault();
            this.recalculateScroll();
        });
        this.recalculateScroll();
        this.TabPage.IsLoading(false);
    }
    recalculateScroll() {
        this.HeaderLeftPos(-window.pageXOffset + 'px');
    }
    BeforeClose(fn) {
        return fn();
    }
}
export default ShiftScheduleViewModel;